module.exports = __webpack_public_path__ + "kg.500d88e9ba759fa80ab1.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/kg.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/kg.svg
// module chunks = styles